import React from 'react';
import Square from './Square';

export default class Board extends React.Component {
  renderSquare(i) {
    const row = Math.floor(i / 9);
    const isSetupValid =
      (this.props.phase === "player1_setup" && row > 4) ||
      (this.props.phase === "player2_setup" && row < 3);
    const isSelected = this.props.selected === i;

    const lom = this.props.lastOpponentMove;
    const showTo = lom && lom.to === i &&
      (lom.type === "move" || lom.outcome === "attacker");
    const showFrom = lom && lom.from === i;

    return (
      <Square
        key={i}
        value={this.props.squares[i]}
        onClick={() => this.props.onClick(i)}
        adjacent={this.props.possibleMoves.includes(i)}
        player={this.props.playerPositions[i]}
        currPlayer={this.props.player}
        isSetupValid={isSetupValid}
        isSelected={isSelected}
        isLastMoveTo={showTo}
        isLastMoveFrom={showFrom && !showTo}
      />
    );
  }

  render() {
    const rows = this.props.flipped
      ? [7, 6, 5, 4, 3, 2, 1, 0]
      : [0, 1, 2, 3, 4, 5, 6, 7];
    const cols = this.props.flipped
      ? [8, 7, 6, 5, 4, 3, 2, 1, 0]
      : [0, 1, 2, 3, 4, 5, 6, 7, 8];

    return (
      <div>
        {rows.map((actualRow, rowIdx) => (
          <div className="board-row" key={rowIdx}>
            {cols.map((actualCol) =>
              this.renderSquare(9 * actualRow + actualCol)
            )}
          </div>
        ))}
      </div>
    );
  }
}
